var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProjectLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8335 5.16667H2.946L5.9735 1.53334C6.26849 1.18001 6.22016 0.654172 5.86683 0.360006C5.51266 0.0650056 4.98766 0.113339 4.69349 0.466672L0.526829 5.46667C0.494329 5.50584 0.477663 5.55167 0.453496 5.59501C0.433496 5.63001 0.409329 5.66001 0.394329 5.69834C0.356829 5.79417 0.334329 5.89501 0.334329 5.99667C0.334329 5.99751 0.333496 5.99917 0.333496 6.00001C0.333496 6.00084 0.334329 6.00251 0.334329 6.00334C0.334329 6.10501 0.356829 6.20584 0.394329 6.30167C0.409329 6.34001 0.433496 6.37001 0.453496 6.40501C0.477663 6.44834 0.494329 6.49417 0.526829 6.53334L4.69349 11.5333C4.85849 11.7308 5.09516 11.8333 5.3335 11.8333C5.52183 11.8333 5.71099 11.77 5.86683 11.64C6.22016 11.3458 6.26849 10.82 5.9735 10.4667L2.946 6.83334H12.8335C13.2935 6.83334 13.6668 6.46001 13.6668 6.00001C13.6668 5.54001 13.2935 5.16667 12.8335 5.16667Z",
    fill: "#335C75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectLeftArrow);
export default __webpack_public_path__ + "static/media/ProjectLeftArrow.4404e092.svg";
export { ForwardRef as ReactComponent };